import { withI18n } from 'panda-i18n';
import locale from "../../locales";
// import { CnCard as CnCardView } from './cn-card';
import CnCardView from './cn-card-view';
export var CnCard = withI18n(CnCardView, { locale: locale });
export * from './types/main';
